// src/pages/SellerIntelligence/PromoCalendar/PromoCalendar.js
//
// Promotional Calendar & Planner.
//
// NOTHING HERE SUBMITS, CREATES OR EDITS ANYTHING ON AMAZON.
//
// SF1 and SF2 are views over Promotion Performance Tracker data with time as
// the axis — its PRD says so outright. SF4 adds allocation and SF5 conflict
// detection. SF3 needs a maintained festival calendar whose ownership is an
// open question in this PRD and in the Seasonal Analyser's.
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';

import styles from '../SellerIntelligence.module.css';
import CalendarView from './components/CalendarView';
import ConflictChecker from './components/ConflictChecker';

const PromoCalendar = () => {
  const navigate = useNavigate();
  return (
    <div className={styles.featureContainer}>
      <div className={styles.header}>
        <button className={styles.backButton}
          onClick={() => navigate('/dashboard/seller-intelligence/pricing')}>
          <FiArrowLeft /> Back
        </button>
        <div className={styles.titleSection}>
          <div className={styles.iconTitle}><h1>Promotional Calendar</h1></div>
          <p>What you have run, what it returned, and where a budget would go next.</p>
        </div>
      </div>
      <div className={styles.content}>
        <CalendarView />
        <ConflictChecker />
      </div>
    </div>
  );
};

export default PromoCalendar;
